import { PaymentMethodCode } from "@omni/types/components/payment/shared/enum/paymentMethodCode.enum";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { SubmitPaymentButton } from "../../submitPaymentButton/submitPaymentButton.container";

type DefaultPaymentComponentProps = {
    code: PaymentMethodCode;
};

const RedirectPaymentComponent = ({ code }: DefaultPaymentComponentProps) => {
    const { t } = useGranite();

    return (
        <>
            <Row className={"py-3"}>
                <Col>
                    <SubmitPaymentButton />
                </Col>
            </Row>
            <Row>
                <p className={"col-12"}>
                    <span className="small font-weight-light">
                        <i className="las la-lock pr-1"></i>
                        {t(`checkout.psp.paymentMethods.description.${code}`)}
                    </span>
                </p>
            </Row>
        </>
    );
};

export { RedirectPaymentComponent };
